<template>
  <VApp>
    <VMain id="app-main" class="main-background">
      <RouterView />
    </VMain>
  </VApp>
</template>

<script setup>
import { defineComponent } from "vue";

defineComponent({
  name: "App",
});
</script>

<style>
.main-background {
  background-color: #f4f6ff;
}
</style>
